// react documenation used: https://react.dev/learn
// ReactRouter documentation used : https://reactrouter.com/web/guides/quick-start
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import styles from "./loginPage.module.css";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const success = await auth.login(email, password); //navigates to authContext file to perform rest of login
    if (success) {
      navigate("/homePage");
    } else {
      alert("Login failed. Check your email and password.");
    }
    setIsLoading(false);
  };

  return (
    <div className={styles["login-container"]}>
      <form className={styles["form_login"]} onSubmit={handleLogin}>
        <img
          src="/repomerge-logo.png"
          alt="RepoMerge Logo"
          className={styles.logo}
        />
        <div className={styles["form-group_login"]}>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Email:"
          />
        </div>
        <div className={styles["form-group_login"]}>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Password:"
          />
        </div>
        <button type="submit">Login</button>
      </form>
      <p className={styles["signup-prompt"]}>
        Don’t have an account? <a href="/signUpPage">Sign Up</a>
      </p>
    </div>
  );
}

export default LoginPage;
